import { memo } from "react";
import Svg, { Defs, LinearGradient, Path, Stop, type SvgProps } from "react-native-svg";

interface HeartFilledProps extends SvgProps {
  gradientPoint?: { offset: string; stopColor: string }[];
}

const SvgHeartFilled = (props: HeartFilledProps) => {
  const { gradientPoint, ...svgProps } = props;
  const gradientId = `heart-gradient-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <Svg fill="none" height={25} width={25} {...svgProps}>
      {gradientPoint && (
        <Defs>
          <LinearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            {gradientPoint.map(({ offset, stopColor }) => (
              <Stop key={`${offset}-${stopColor}`} offset={offset} stopColor={stopColor} />
            ))}
          </LinearGradient>
        </Defs>
      )}
      <Path
        d="M21.833 4.369a6.1 6.1 0 0 0-4.403-1.88c-1.672.002-3.268 1.4-4.408 2.597l-.389.401-.388-.401C9.984 2.704 6.177 1.85 3.743 4.063q-.162.147-.312.305a6.496 6.496 0 0 0 0 8.976l9.2 9.145 9.202-9.145a6.496 6.496 0 0 0 0-8.975"
        fill={gradientPoint ? `url(#${gradientId})` : props.color}
      />
    </Svg>
  );
};
const Memo = memo(SvgHeartFilled);
export default Memo;
